import { Component, OnInit } from '@angular/core';
// Forms
import { FormGroup, FormGroupDirective} from '@angular/forms';

@Component({
  selector: 'app-vehicle-identification',
  templateUrl: './vehicle-identification.component.html',
  styleUrls: ['./vehicle-identification.component.scss'],
})
export class VehicleIdentificationComponent  implements OnInit {

  /**
   * Variables
   */
  VehicleForm: FormGroup;

  constructor(private rootFormGroup: FormGroupDirective) {}

  // #region --> LifeCycle

  /**
   * Every time the component is rendered, we take from the parent the vehicle form.
   */
  ngOnInit() {
    this.VehicleForm = this.rootFormGroup.control;
  }

  // #endregion --> LifeCycle

}

